<img *ngIf="!image" src="/images/fallback-product.png">
    	       <img *ngIf="image" src="https://img.noviflora.nl/Images/{{image}}{{getImageFormat()}}.jpg" alt="{{description}}">